import { createContext, useContext, type ReactNode } from 'react';
import type { Edge } from 'reactflow';
import type { CustomNode } from '../types/nodes';
import type { ContextField, NodeContext } from '../types/workflow-context';

type WorkflowContextType = {
	undo: () => void;
	redo: () => void;
	canUndo: boolean;
	canRedo: boolean;
	nodes: CustomNode[];
	edges: Edge[];
	getAvailableFields: (nodeId: string) => NodeContext[];
	getFlattenedFields: (nodeId: string) => ContextField[];
	getCurrentFlowId: () => string | null;
};

const WorkflowContext = createContext<WorkflowContextType | null>(null);

export function useWorkflowContext() {
	const context = useContext(WorkflowContext);
	if (!context) {
		throw new Error('useWorkflowContext must be used within a WorkflowProvider');
	}
	return context;
}

type WorkflowProviderProps = {
	children: ReactNode;
	value: WorkflowContextType;
};

export function WorkflowProvider({ children, value }: WorkflowProviderProps) {
	return (
		<WorkflowContext.Provider value={value}>
			{children}
		</WorkflowContext.Provider>
	);
} 